import React, { useEffect, useState } from "react";

import { supabase } from "../../../supabaseClient";
import SquadList from "../../SquadList/SquadList";
import BulkCreateSquads from "../../createSquad/BulkCreateSquads";
import { SecondaryButton } from "../../UI/DesignStandards";
import { FaPlus } from "react-icons/fa";
import { useTournamentId } from "../../../context/TournamentRouteContext";

const SquadManagementTab = ({ eventsRevision = 0, onSquadsChange }) => {
  const tournamentId = useTournamentId();
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [squadCount, setSquadCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    supabase
      .from("squads")
      .select("id", { count: "exact", head: true })
      .eq("tournamentID", tournamentId)
      .eq("isDeleted", false)
      .then(({ count, error }) => {
        if (cancelled || error) return;
        const nextCount = count || 0;
        setSquadCount(nextCount);
        if (nextCount === 0) setShowCreateForm(true);
      });
    return () => {
      cancelled = true;
    };
  }, [tournamentId, refreshKey]);

  const handleSquadCreated = () => {
    setShowCreateForm(false);
    setRefreshKey((prevKey) => prevKey + 1);
    onSquadsChange?.();
  };

  const noSquads = squadCount === 0;
  const shouldShowCreateForm = noSquads || showCreateForm;

  return (
    <div className="card-board p-6 mb-6">
      <div className="flex justify-between items-center mb-6">
        <h2 className="heading-display text-xl">Squads</h2>
        {squadCount > 0 && !shouldShowCreateForm ? (
          <SecondaryButton
            onClick={() => setShowCreateForm(true)}
            className="!px-3 !py-2 text-sm"
          >
            <FaPlus className="mr-2 h-4 w-4" />
            Add Squad
          </SecondaryButton>
        ) : null}
      </div>

      {shouldShowCreateForm ? (
        <div className={squadCount > 0 ? "mb-6" : ""}>
          <BulkCreateSquads
            tournamentID={tournamentId}
            eventsRevision={eventsRevision}
            onCreated={handleSquadCreated}
            onCancel={
              squadCount > 0 ? () => setShowCreateForm(false) : null
            }
            openTemplatesByDefault={noSquads}
          />
        </div>
      ) : null}

      {squadCount > 0 ? (
        <SquadList
          tournamentID={tournamentId}
          key={refreshKey}
          embedded
          onSquadsChange={onSquadsChange}
        />
      ) : null}
    </div>
  );
};

export default SquadManagementTab;
